/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import LazyImageRenderComponent from '@components/UI/LazyImageRenderComponent';

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const ImageBannerAdWOB = ({ sectionContent, sectionId }) => {
  const isTabScreen = useMediaQuery({ maxWidth: 767 });
  const isWebScreen = useMediaQuery({ maxWidth: 1024 });
  return (
    <Box
      textAlign="center"
      position="relative"
      pt={{ base: '36px', md: '0', lg: '0' }}
      mb={{ base: '22px', md: '0px' }}
      px={{ base: '16px', md: '0px' }}
      mx="0px"
      width={'100%'}
      height={'100%'}
      lineHeight="0px"
    >
      <LazyImageRenderComponent
        alt={sectionContent?.image?.title}
        title={sectionContent?.image?.title}
        textAlign="center"
        src={
          isTabScreen
            ? sectionContent?.mobileImage?.url || sectionContent?.image?.url
            : isWebScreen
            ? sectionContent?.tabletImage?.url || sectionContent?.image?.url
            : sectionContent?.image?.url
        }
        w={'100%'}
        h="100%"
      />
    </Box>
  );
};

export default ImageBannerAdWOB;
